module.exports = __webpack_public_path__ + "static/media/request_icon.1b509d51.svg";